import { motion } from "framer-motion";
import { Bell, Flame, Gift, Menu, Sparkles, User } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import ArthereumIcon from "../../WebAppsSharedStuffs/components/ArtheumIcon";
import MobileDrawer from "./MobileDrawer";
import { PAGE_NAME, UserModelData } from "../../types";


interface MobileTopNavProps {
  openProModal: () => void;
}

const MobileTopNav: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
 
 
  const location = useLocation();

  
   const userData: UserModelData = useSelector(
      (state) => (state as any)?.actualUser
    );
  

  return (
    <>
      <motion.div
        className="md:hidden w-full fixed top-0 left-0 right-0 h-16 bg-white/90 backdrop-blur-md shadow-sm z-50 flex items-center px-3 gap-2.5 border-b border-gray-100"
        initial={{ y: -64, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{
          type: "spring",
          stiffness: 300,
          damping: 30,
          opacity: { duration: 0.2 },
        }}
      >
        {/* Menu Button */}
        <motion.button
          onClick={() => setIsDrawerOpen(true)}
          className="flex-shrink-0 w-10 h-10 rounded-xl bg-gray-50 hover:bg-gray-100 flex items-center justify-center transition-colors"
          whileTap={{ scale: 0.95 }}
        >
          <Menu className="w-5 h-5 text-gray-700" strokeWidth={2} />
        </motion.button>

        {/* Spacer to push right items to the end */}
        <div className="flex-1">
          {/* arthereum Balance */}
          <Link to="/deposit" className="flex-shrink-0">
            <motion.div
              className="flex items-center gap-1.5 bg-orange-50 hover:bg-orange-100 rounded-xl px-2.5 py-1.5 border border-orange-200 transition-colors"
              whileTap={{ scale: 0.95 }}
            >
              <ArthereumIcon className="w-4 h-4 text-orange-500" />
              <span className="font-semibold text-orange-800 text-xs whitespace-nowrap">
                {userData?.user?.arthereumBalance?.toFixed(2)}
                ATH
              </span>
            </motion.div>
          </Link>
        </div>

        {/* Notifications Button */}
        <Link to="/notifications" className="flex-shrink-0">
          <motion.button
            className="flex-shrink-0 w-10 h-10 rounded-xl bg-gray-50 hover:bg-gray-100 flex items-center justify-center transition-colors relative"
            whileTap={{ scale: 0.95 }}
          >
            <Bell className="w-5 h-5 text-gray-700" strokeWidth={2} />
            {0 > 0 && (
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center text-white text-xs font-bold shadow-md"
              >
                {0 > 9 ? "9+" : 0}
              </motion.div>
            )}
          </motion.button>
        </Link>

        {/* Pro Button */}
        {/* <motion.button
          onClick={openProModal}
          className="flex-shrink-0 flex items-center gap-1.5 bg-gradient-to-r from-purple-500 to-indigo-600 hover:from-purple-600 hover:to-indigo-700 rounded-xl px-2.5 py-1.5 shadow-sm transition-all"
          whileTap={{ scale: 0.95 }}
        >
          <Sparkles className="w-4 h-4 text-white" strokeWidth={2} />
          <span className="font-semibold text-white text-xs">Pro</span>
        </motion.button> */}

        {/* Profile Avatar */}
        <Link
          to={PAGE_NAME.PROFILE}
          className="flex-shrink-0"
        >
          <motion.div className="relative" whileTap={{ scale: 0.95 }}>
            {userData?.user?.profileImage ? (
              <div className="w-10 h-10 rounded-xl overflow-hidden border border-gray-200">
                <img
                  src={userData?.user?.profileImage}
                  alt="Profile"
                  className="w-full h-full object-cover"
                />
              </div>
            ) : userData?.user ? (
              <div className="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center border border-gray-200">
                <User className="w-5 h-5 text-gray-500" strokeWidth={2} />
              </div>
            ) : (
              <div className="w-10 h-10 rounded-xl bg-gray-200 animate-pulse" />
            )}
            <div className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 bg-green-500 rounded-full border-2 border-white" />
          </motion.div>
        </Link>
      </motion.div>

      <MobileDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
    </>
  );
};

export default MobileTopNav;
